export class AccountStateLogEntry {
    id: number;
    accountId: number;
    accountState: string;
    userInitiatorId: number;
    userInitiatorName: string;
    reason: string;
    changeDateTime: string;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/api/entity/account_state_log.ts